import { ArrowDown, Anchor, Waves, Fish } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Harvesting() {
  const badges = [{
    label: "WILD-CAUGHT",
    rotation: "-rotate-3"
  }, {
    label: "SUSTAINABLE",
    rotation: "rotate-2"
  }, {
    label: "GULF-SOURCED",
    rotation: "-rotate-2"
  }];
  const polaroids = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/miss_yvonne_deck.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/miss_yvonne_deck.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/miss_yvonne_deck.png-wvc-sizes",
    alt: "The Miss Yvonne fishing vessel deck",
    caption: "the miss yvonne — 1965",
    rotation: "-rotate-6",
    tapeColor: "bg-primary/20",
    tapeRotation: "-rotate-12",
    offset: "md:translate-x-0 md:translate-y-0"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/fresh_catch_tuna.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/fresh_catch_tuna.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/fresh_catch_tuna.webp-wvc-sizes",
    alt: "Freshly caught tuna on ice",
    caption: "wild-caught quality",
    rotation: "rotate-4",
    tapeColor: "bg-primary/20",
    tapeRotation: "rotate-12",
    offset: "md:translate-x-8 md:-translate-y-4"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/seafood_market_display.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/seafood_market_display.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721626/img/seafood_market_display.png-wvc-sizes",
    alt: "Premium seafood market display",
    caption: "shore to door",
    rotation: "-rotate-3",
    tapeColor: "bg-primary/20",
    tapeRotation: "rotate-6",
    offset: "md:-translate-x-4 md:translate-y-2"
  }];
  return <section data-section-id="1104" id="responsible-harvesting" className="relative w-full overflow-hidden bg-background py-24 md:py-32">
      <Anchor className="absolute top-12 left-[8%] size-8 -rotate-12 text-primary opacity-20" strokeWidth={1} aria-hidden="true" />
      <Waves className="absolute top-24 right-[12%] size-10 rotate-12 text-primary opacity-20" strokeWidth={1} aria-hidden="true" />
      <Fish className="absolute bottom-32 left-[6%] size-7 rotate-12 text-primary opacity-20" strokeWidth={1} aria-hidden="true" />
      <Anchor className="absolute bottom-16 right-[8%] size-9 -rotate-6 text-primary opacity-20" strokeWidth={1} aria-hidden="true" />
      <Waves className="absolute top-1/2 left-[45%] size-6 rotate-45 text-primary/10 hidden lg:block" strokeWidth={1} aria-hidden="true" />

      <div className="container relative mx-auto max-w-[1440px] px-8 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <div className="mb-6 inline-flex items-center gap-3">
              <span className="font-mono text-xs font-medium tracking-[0.25em] text-primary uppercase md:text-sm">
                § 01 // HARVESTING
              </span>
              <span className="h-px w-12 bg-primary" aria-hidden="true" />
            </div>

            <h1 className="font-serif font-bold text-foreground" style={{
            fontSize: "clamp(2.5rem, 8vw, 5.5rem)",
            letterSpacing: "-0.03em",
            lineHeight: "0.95"
          }}>
              BUILT BY HAND.{" "}
              <span className="relative inline-block">
                <span className="relative z-10 italic">PROVEN BY TIME.</span>
                <svg className="absolute -inset-x-4 -inset-y-3 z-0 h-[calc(100%+1.5rem)] w-[calc(100%+2rem)]" viewBox="0 0 300 140" fill="none" preserveAspectRatio="none" aria-hidden="true">
                  <path d="M150 12 C 80 14, 28 35, 22 70 C 18 105, 75 128, 152 128 C 232 128, 285 108, 282 72 C 280 38, 222 16, 150 12 Z" stroke="hsl(28 85% 58%)" strokeWidth="1" strokeLinecap="round" fill="none" strokeDasharray="900" strokeDashoffset="900" style={{
                  animation: "drawCircle 0.9s ease-out 0.3s forwards"
                }} />
                </svg>
              </span>
            </h1>

            <p className="mt-8 max-w-2xl font-sans font-normal text-muted-foreground" style={{
            fontSize: "clamp(1.125rem, 1.5vw, 1.25rem)",
            lineHeight: "1.6"
          }}>
              The Miss Yvonne represents decades of sustainable fishing practices, 
              delivering wild-caught seafood sourced the right way from our 
              historic vessel to your table.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              {badges.map((badge, i) => <div key={badge.label} data-index={i} className={`inline-block ${badge.rotation} border border-primary bg-transparent px-8 py-3 font-mono text-xs font-medium tracking-[0.25em] text-primary uppercase transition-transform duration-200 hover:rotate-0 md:text-sm`}>
                  {badge.label}
                </div>)}
            </div>

            <div className="mt-12">
              <Button asChild className="group h-auto border-none bg-secondary px-10 py-4 font-mono text-base font-bold tracking-[0.1em] text-white uppercase transition-all duration-150 hover:bg-foreground md:text-lg">
                <Link to="/ShopPage">
                  SHOP THE CATCH
                  <ArrowDown className="ml-2 size-5 transition-transform group-hover:translate-y-1" strokeWidth={2} />
                </Link>
              </Button>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="grid grid-cols-2 gap-6 md:gap-8 lg:flex lg:flex-col lg:gap-10">
              {polaroids.map((p, i) => <div key={p.caption} data-index={i} className={`relative ${p.rotation} ${p.offset} ${i === 2 ? "col-span-2 mx-auto w-3/4 md:w-1/2 lg:w-auto" : ""} transition-transform duration-300 hover:rotate-0`}>
                  <div className={`absolute -top-3 left-1/2 z-20 h-6 w-20 ${p.tapeColor} ${p.tapeRotation} -translate-x-1/2 opacity-40`} aria-hidden="true" />
                  <div className="bg-card p-3 pb-12" style={{
                boxShadow: "0 10px 30px -15px rgba(0,0,0,0.1)"
              }}>
                    <div className="aspect-[4/5] w-full overflow-hidden bg-muted">
                      <img src={p.src} data-wvc-srcset={p.srcset} data-wvc-sizes={p.sizes} alt={p.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" />
                    </div>
                    <p className="mt-4 text-center font-mono text-xs font-medium uppercase tracking-[0.2em] text-primary md:text-sm">
                      {p.caption}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes drawCircle {
          to {
            stroke-dashoffset: 0;
          }
        }
      `}</style>
    </section>;
}